import { useState } from "react";
import PropTypes from "prop-types";
import "./ImportarUsuarios.css";
import { toast } from "react-toastify";
import Preloader from "../../components/Preloader";
import { UsuarioService } from "../../services/UsuarioService";

const ImportarUsuarios = ({ onClose, token, onSuccess }) => {
  const [archivo, setArchivo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setArchivo(e.target.files[0]);
  };

  const handleImportar = async () => {
    if (!archivo) return;
    setLoading(true);

    try {
      const { success, resultados } = await UsuarioService.importarUsuarios({ token, archivo });

      if (success) {
        const errores = resultados.filter((r) => r.accion === "error");

        if (resultados.length > 0 && errores.length > 0) {
          let contenidoTexto = "Reporte de Errores en la Importación de Usuarios\n";
          contenidoTexto += "=".repeat(40) + "\n\n";

          errores.forEach((e, index) => {
            contenidoTexto += `Error #${index + 1}\n`;
            contenidoTexto += `Documento: ${e.documento}\n`;
            contenidoTexto += `Motivo: ${e.motivo}\n`;
            contenidoTexto += "-".repeat(20) + "\n";
          });

          const blob = new Blob([contenidoTexto], { type: "text/plain;charset=utf-8" });

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "errores_importacion_usuarios.txt";

          document.body.appendChild(link); 
          link.click();
          link.remove();

          toast.info("Se ha descargado el reporte de errores.", {
            position: "top-center",
            autoClose: 3000,
          });
        } else {
          toast.success("Usuarios Importados Exitosamente", {
            position: "top-center",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      }

      onSuccess();
      onClose();
    } catch (error) {
      const mensajeError = error.response?.data?.error || "Error inesperado al importar";
      toast.error(` ${mensajeError}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay-import">
      {loading && <Preloader />}
      <div className="modal-box-import">
        <div className="modal-header">
          <span> Importar Usuarios</span>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-content-import">
          <label htmlFor="archivo">Selecciona un archivo Excel:</label>
          <input
            type="file"
            id="archivo"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
          />
          <span style={{ marginTop: "20px", textAlign: "center" }}>
            <a
              href="/formatos/Usuarios.xlsx"
              download
              style={{
                textDecoration: "none",
                color: "#333",
                fontWeight: "500",
                fontSize: "14px",
                display: "inline-block",
              }}
            >
              Descargar formato de ejemplo para importar
            </a>
          </span>
        </div>

        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancelar
          </button>
          <button className="save-btn" onClick={handleImportar}>
            Importar
          </button>
        </div>
      </div>
    </div>
  );
};

ImportarUsuarios.propTypes = {
  onClose: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default ImportarUsuarios;
